module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-instagram-2.558d73cd.jpg";